<esn-icon class="esn-cti__glyph" [name]="type()" [size]="20" />
@if (external()) {
  <span class="esn-cti__badge"><esn-icon name="external-source" [size]="12" /></span>
}
